import React, { useEffect, useState } from "react";
import { Link as RouterLink, Navigate, useNavigate } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { AppBar, Box, IconButton, Toolbar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import InputIcon from "@mui/icons-material/Input";
import { Dashboard } from "@mui/icons-material";
import { ReactComponent as Logo } from "../../theme/icons/logo-nou.svg";
import theme from "../../theme";

const TopBar = ({ className, onMobileNavOpen, ...rest }) => {
	const [isLogged, setIsLogged] = useState(
		localStorage.getItem("isLoggedIn") === "true"
	);
	let navigate = useNavigate();

	useEffect(() => {
		setIsLogged(localStorage.getItem("isLoggedIn") === "true");
	}, []);

	const logOut = () => {
		localStorage.removeItem("user");
		localStorage.removeItem("isLoggedIn");
		setIsLogged(false);
		navigate("/");
	};

	return (
		<AppBar
			elevation={0}
			{...rest}
			style={{ backgroundColor: theme.palette.admin.primary }}
		>
			<Toolbar>
				<RouterLink to="/">
					<Logo
						fill="white"
						style={{ width: 200, height: 50, marginTop: 5 }}
					/>
					{/* <SvgIcon className={classes.icon} component={Logo} viewBox="0 0 24 5" /> */}
				</RouterLink>
				<Box flexGrow={1} />
				<Box>
					{isLogged ? (
						<>
							<IconButton
								color="inherit"
								onClick={() => navigate("/")}
							>
								<Dashboard />
							</IconButton>
							<IconButton
								color="inherit"
								onClick={() => logOut()}
							>
								<InputIcon />
							</IconButton>
						</>
					) : (
						<IconButton
							color="inherit"
							onClick={() => navigate("/admin/alumnes")}
						>
							<Dashboard />
						</IconButton>
					)}
				</Box>
				<Box sx={{ display: { md: "none", xs: "block" } }}>
					<IconButton color="inherit" onClick={onMobileNavOpen}>
						<MenuIcon />
					</IconButton>
				</Box>
			</Toolbar>
		</AppBar>
	);
};

TopBar.propTypes = {
	className: PropTypes.string,
	onMobileNavOpen: PropTypes.func,
};

export default TopBar;
